import StyleTypes from '../../../types/StyleTypes';
export default function onArrowRight(event, editor, next) {
  var _editor$value = editor.value,
      endBlock = _editor$value.endBlock,
      selection = _editor$value.selection;
  var lastTextNode = endBlock.getLastText();
  var isInLastTextNode = lastTextNode.key === selection.focus.key;
  var isSelectionAtTheEndOfNode = lastTextNode.text.length === selection.focus.offset;

  if (!isInLastTextNode || !selection.isCollapsed || !isSelectionAtTheEndOfNode) {
    return next();
  }

  event.preventDefault();
  return editor.toggleMark(StyleTypes.CODE).insertText(' ');
}